<template>
  <div class="About" style="padding-top:20px">
    <van-cell-group>
      <van-cell title="登录用户" :value="username" icon="user-circle-o" />
      <van-cell title="组织信息" :value="department" icon="wap-home-o" />
    </van-cell-group>
    <van-cell-group style="margin-top:20px">
      <van-cell title="我的会议" icon="records" is-link @click="onClickMeeting()" />
    </van-cell-group>
    <van-cell-group style="margin-top:20px">
      <van-cell title="清空缓存" icon="certificate" is-link @click="onClick" />
    </van-cell-group>

    <!-- <van-cell-group style="margin-top:20px">
      <van-cell title="经理角色(测试用)" icon="manager" is-link @click="onClick1" />
      <van-cell title="部长角色(测试用)" icon="user-o" is-link @click="onClick2" />
      <van-cell title="组长角色(测试用)" icon="contact" is-link @click="onClick3" />
    </van-cell-group> -->
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'About',
  components: { },
  data() {
    return {
      username: '',
      department: ''
    }
  },
  created() {
    const self = this
    request({ url: '/C00/UserInfo', params: { user_code: this.$store.getters.usercode }})
      .then(function(response) {
        self.username = response.data.user_name + ' (' + response.data.user_code + ')'
        self.department = response.data.department_name
      })
  },
  methods: {
    // 我的会议
    onClickMeeting() {
      console.log('wode ')
      this.$router.push(
        { path: '/index/myMeeting' }
      )
    },
    onClick() {
      localStorage.clear('userCode')
      this.$toast.success('Successed')
      this.$store.dispatch('user/logout')
        .then(() => {
          console.log('Login logout ')
          window.location.replace('login.html')
        })
    },
    onClick1() {
      localStorage.setItem('userCode', '2008001')
      this.login()
    },
    onClick2() {
      localStorage.setItem('userCode', '2012077')
      this.login()
    },
    onClick3() {
      localStorage.setItem('userCode', '2015002')
      this.login()
    },
    login() {
      var usercode = localStorage.getItem('userCode')
      this.$store.dispatch('user/login', usercode)
        .then(() => {
          console.log('Login Succeseed ' + usercode)
          location.reload()
          this.loading = false
        })
        .catch(() => {
          console.log('Login Failed')
          this.loading = false
        })
    }
  }
}
</script>
